import { useEffect, useState } from 'react';

import { Icon } from '@@/Icon';
import { Button } from '@@/buttons';
import { useLogViewerContext } from '@@/LogViewer/context';

export function FullScreenButton({ className }: { className?: string }) {
  const { logViewerRef } = useLogViewerContext();

  const [isFullScreen, setIsFullScreen] = useState(false);

  async function toggleFullScreen() {
    if (isFullScreen) {
      await document.exitFullscreen();
    } else {
      await logViewerRef.current?.requestFullscreen();
    }
  }

  useEffect(() => {
    document.onfullscreenchange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    return () => {
      document.onfullscreenchange = null;
    };
  }, []);

  return (
    <Button
      data-cy="logs-full-screen-button"
      onClick={toggleFullScreen}
      disabled={!document.fullscreenEnabled}
      color="none"
      title={isFullScreen ? 'Exit full screen' : 'Full screen'}
      className={className}
    >
      <Icon icon={isFullScreen ? 'minimize-2' : 'maximize-2'} />
    </Button>
  );
}
